import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { OnboardingService } from '../../onboarding/services/onboarding.service';
import { OnboardingStep } from '../../onboarding/models';

export const SubscriptionAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const onboardingService = inject(OnboardingService);

  // Check if there's stored onboarding data
  const storedStep = localStorage.getItem('onboarding_current_step');
  const shopData = localStorage.getItem('onboarding_shop_data');

  // If no shop data exists, user is not in onboarding - allow access
  if (!shopData) {
    return true;
  }

  // If we have a stored step, check it first
  if (storedStep) {
    const currentStep = parseInt(storedStep) as OnboardingStep;
    
    // If shop is ready (step >= 18), allow access
    if (currentStep >= OnboardingStep.ShopReadyToUse) {
      return true;
    }
    
    // Otherwise, redirect to waiting screen
    router.navigate(['/subscription/waiting']);
    return false;
  }

  // Try to get current step from API
  return onboardingService.getOnboardingStep().pipe(
    map(response => {
      if (response) {
        const currentStep = response.step as OnboardingStep;
        
        // If shop is ready, allow access
        if (currentStep >= OnboardingStep.ShopReadyToUse) {
          return true;
        }
        
        // Otherwise, redirect to waiting screen
        router.navigate(['/subscription/waiting']);
        return false;
      }
      
      // No shop found - user is not in onboarding, allow access
      return true;
    }),
    catchError(error => {
      // On error, check if it's because shop doesn't exist (404)
      if (error.status === 404) {
        // No shop - user is not in onboarding, allow access
        return of(true);
      }
      
      // For other errors, log and allow access (fail open)
      console.error('Subscription guard error:', error);
      return of(true);
    })
  );
};
